import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import HeadingTextBlock from 'components/Luxkit/TextBlocks/HeadingTextBlock'
import React, { useCallback, useContext, useMemo } from 'react'
import { LuxAwardModalDispatchActions, LuxAwardModalDispatchContext, LuxAwardModalStateContext } from './LuxAwardModalContexts'
import TextButton from 'components/Luxkit/Button/TextButton'
import { PRIZES } from './luxAwardPrizes'
import Group from 'components/utils/Group'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import LineAngleLeftIcon from 'components/Luxkit/Icons/line/LineAngleLeftIcon'
import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import ModalImageThumbnail from 'components/Luxkit/Modal/ModalImageThumbnail'

interface Props {
  prizeKey: string
  exploreUrl: string
}

function LuxAwardModalStepPrize(props: Props) {
  const { prizeKey } = props
  const prize = useMemo(() => PRIZES.find(prize => prize.key === prizeKey), [prizeKey])
  const state = useContext(LuxAwardModalStateContext)
  const dispatch = useContext(LuxAwardModalDispatchContext)
  const canGoPrev = useMemo(() => {
    return state.steps.indexOf(state.currentStep) > 1
  }, [state.currentStep, state.steps])

  const canGoNext = useMemo(() => {
    return state.steps.indexOf(state.currentStep) < state.steps.length - 1
  }, [state.currentStep, state.steps])

  const goHome = useCallback(() => {
    dispatch({ type: LuxAwardModalDispatchActions.GO_HOME })
  }, [dispatch])

  const goNext = useCallback(() => {
    dispatch({ type: LuxAwardModalDispatchActions.GO_NEXT })
  }, [dispatch])

  const goPrev = useCallback(() => {
    dispatch({ type: LuxAwardModalDispatchActions.GO_PREVIOUS })
  }, [dispatch])
  if (!prize) {
    return null
  }
  return <>
    <ModalHeader
    title={prize.type}
    subtitle="Back to prizes"
    onBackButtonClick={goHome}
    />
    <ModalBody>
      <ModalImageThumbnail image={prize.image} imageParams={{ aspectRatio: '3.15' }} />
      <ModalContent>
        <Group direction="vertical" gap={12}>
          <HeadingTextBlock variant="heading3">{prize.title}</HeadingTextBlock>
          <MarkdownRender fontSize="medium" type="compact" content={prize.description} />
        </Group>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: 'Explore escapes',
        to: props.exploreUrl,
      }}
    >
      <Group direction="horizontal" horizontalAlign="space-between" fullWidth>
        <TextButton kind="tertiary" onClick={goPrev} disabled={!canGoPrev} startIcon={<LineAngleLeftIcon />} >View previous</TextButton>
        <TextButton kind="tertiary" onClick={goNext} disabled={!canGoNext} endIcon={<LineAngleRightIcon />}>View next</TextButton>
      </Group>
    </ModalFooter>
  </>
}

export default LuxAwardModalStepPrize
